import { useState, useEffect } from 'react';

function usePostLimit(numberOfRows, currentDate) {
  const [postsLimit, setPostsLimit] = useState([]);

  // Set default to 5 and reset state values when navigate to another month
  useEffect(() => {
    setPostsLimit(Array(numberOfRows).fill(5));
  }, [currentDate]);

  const showMorePosts = index => {
    const array = postsLimit.map((item, i) => {
      if (i === index) {
        return item + 5;
      }
      return item;
    });
    setPostsLimit(array);
  };

  return {
    postsLimit,
    showMorePosts,
  };
}

export default usePostLimit;
